module.exports = __webpack_public_path__ + "media/src/ui/icons/iconEarth-6885638e4828e0947bf28b938c53a9c6.svg";